import apiService from '../Api'
import { JobPosition, JobPositionInput } from './types'

export class JobPositionService {
  async list(): Promise<JobPosition[]> {
    return apiService.get('/job-position').then((response) => response.data)
  }

  async create(jobPosition: JobPositionInput): Promise<JobPosition> {
    return apiService.post('/job-position', jobPosition).then((response) => response.data)
  }

  async update(id: number, jobPosition: JobPositionInput): Promise<JobPosition> {
    return apiService.put(`/job-position/${id}`, jobPosition).then((response) => response.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/job-position/${id}`)
  }

  async updateStatus(id: number, newStatus: 'active' | 'paused'): Promise<JobPosition> {
    return apiService.put(`/job-position/${id}/update-status`, { status: newStatus }).then((response) => response.data)
  }
}
